import React, {ReactElement} from 'react';
import UpArrow from '@assets/images/medops/up_arrow.svg';
import {useTranslation} from 'react-i18next';

const UpArrowIcon = (props: any): ReactElement => {
  const {t} = useTranslation();
  return (
    <img
      src={UpArrow}
      height={15}
      width={15}
      {...props}
      alt={t('DUE_INVOICES.UP_ARROW')}
    />
  );
};
export default UpArrowIcon;
